<ion-icon *ngIf="ionName" [name]="ionName"></ion-icon>
<i *ngIf="customName" class="custom-icon" [ngClass]="customName"></i>
<i *ngIf="className" [ngClass]="className"></i>
